import React from 'react'
import clsx from 'clsx'
import {
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage
} from '@mui/icons-material'

import useStyles from './styles'

const NORMAL_BUTTONS = {
  first: 'FIRST PAGE',
  previous: 'PREVIOUS PAGE',
  next: 'NEXT PAGE',
  last: 'LAST PAGE'
}

const SMALL_BUTTONS = {
  first: <FirstPage />,
  previous: <KeyboardArrowLeft />,
  next: <KeyboardArrowRight />,
  last: <LastPage />
}

const NavButtons = ({ count, page, rowsPerPage, onChangePage, isSmall }) => {
  const classes = useStyles({ isSmall })

  const buttons = React.useMemo(
    () => (isSmall ? SMALL_BUTTONS : NORMAL_BUTTONS),
    [isSmall]
  )

  const lastPageIdx = React.useMemo(() => Math.ceil(count / rowsPerPage) - 1, [
    count,
    rowsPerPage
  ])
  const onFirstPage = React.useMemo(() => page === 0, [page])
  const onLastPage = React.useMemo(() => page >= lastPageIdx, [
    page,
    lastPageIdx
  ])
  const pages = React.useMemo(() => {
    let pages = []
    if (onFirstPage || page === 1) {
      pages = [0, 1, 2, 3, 4]
    } else if (onLastPage || page === lastPageIdx - 1) {
      pages = [
        lastPageIdx - 4,
        lastPageIdx - 3,
        lastPageIdx - 2,
        lastPageIdx - 1,
        lastPageIdx
      ]
    } else {
      pages = [page - 2, page - 1, page, page + 1, page + 2]
    }
    return pages.filter(p => p >= 0 && p <= lastPageIdx)
  }, [onFirstPage, page, onLastPage, lastPageIdx])

  const handleFirstButtonClick = () => {
    if (!onFirstPage) {
      onChangePage(0)
    }
  }

  const handleBackButtonClick = () => {
    if (!onFirstPage) {
      onChangePage(page - 1)
    }
  }

  const handleNextButtonClick = () => {
    if (!onLastPage) {
      onChangePage(page + 1)
    }
  }

  const handleLastButtonClick = () => {
    if (!onLastPage) {
      onChangePage(lastPageIdx)
    }
  }

  return (
    <div className={classes.root}>
      <div
        onClick={handleFirstButtonClick}
        className={clsx(classes.text, onFirstPage && classes.disabled)}
      >
        {buttons.first}
      </div>

      <div
        onClick={handleBackButtonClick}
        className={clsx(classes.text, onFirstPage && classes.disabled)}
        style={{ margin: '0 8px' }}
      >
        {buttons.previous}
      </div>

      {pages.map((p, i) => (
        <div
          key={i}
          onClick={() => onChangePage(p)}
          className={clsx(classes.page, page === p && classes.pageActive)}
        >
          {p + 1}
        </div>
      ))}

      <div
        onClick={handleNextButtonClick}
        className={clsx(classes.text, onLastPage && classes.disabled)}
        style={{ margin: '0 8px' }}
      >
        {buttons.next}
      </div>

      <div
        onClick={handleLastButtonClick}
        className={clsx(classes.text, onLastPage && classes.disabled)}
      >
        {buttons.last}
      </div>
    </div>
  )
}

export default NavButtons
